// utils/rules.js
import { validatePhone } from "./common";

export const phoneNumberRules = (countryCode) => [
  { test: (val) => !!val, message: "Please enter Phone Number" },
  { test: (val) => validatePhone(val), message: "Enter a valid Phone Number" },
  {
    test: (val) => {
      const min = countryCode.key === "IN" ? 10 : countryCode.phoneLength;
      return val.length >= min;
    },
    message: "Invalid phone number length",
  },
];
